﻿import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_services';
import { Pedido, Item, Lista, Producto } from 'src/app/_models';
import { GoogleAnalyticsService } from 'src/app/_services/analytics.service';



@Component({ templateUrl: 'lista.regalos.component.html' })
export class ListaRegalosComponent implements OnInit {

    nombre: string;

    codigo: string;

    lista: Lista;

    todosLosProductos: Array<Producto>;

    productos: Array<Producto>;

    orden: string = 'na';

    filtro: string = '';

    pedido: Pedido = new Pedido();

    mercadoPago: boolean = false;

    error: boolean = false;

    anonima: boolean = false;


    constructor(
        private restService: RestService, 
        private route: ActivatedRoute, 
        private alertService: AlertService, 
        private router: Router,
        private googleAnalyticsService: GoogleAnalyticsService) {
        // this.ngOnInit();
    }


    ngOnInit() {
        this.lista = null;
        this.restService.getParam('mercadolibre').subscribe(data => {
            this.mercadoPago = data.valor.toString().toUpperCase() === 'TRUE';
        });
        this.error = false;
        this.route.queryParams.subscribe(params => {
            if (params['nombre']) {
                this.nombre = params['nombre'];
            } else {
                this.nombre = null;
            }
            if (params['codigo']) {
                this.codigo = params['codigo'];
            } else {
                this.codigo = null;
            }
            
            if (this.nombre && this.codigo) {
                this.loadProductos();
                this.loadLista();
            } else {
                if (params['anonima']) {
                    this.anonima = true;
                    this.nombre='anonima';
                    this.loadProductos();
                    this.lista = new Lista();
                } else {
                    this.lista = null;
                    this.error = true;
                }
            }
        });
    }

    resumen() {
        if (this.pedido.total() > 0) {
            this.router.navigate(['/resumen'], {
                 queryParams: {
                    pedido: JSON.stringify(this.pedido), 
                    nombre: this.nombre, 
                    codigo: this.codigo, 
                    idLista: this.lista.id, 
                    anonima: this.anonima,
                    // monetizada: this.lista.monetizada
                }
            });
        }
    }

    // private esMonetizada(): boolean {
    //     return this.mercadoPago && this.lista.monetizada;
    // }

    private clickOrdenar() {
        this.googleAnalyticsService.eventEmitter("ecommerce", this.nombre, "ordenar" , this.orden);
        this.ordenar();
    }

    private ordenar() {
        if (this.productos.length > 0) {
            if (this.orden === 'na') {
                this.productos.sort((a, b) => a.nombre.localeCompare(b.nombre));
            } else if (this.orden === 'nd') {
                this.productos.sort((a, b) => b.nombre.localeCompare(a.nombre));
            } else if (this.orden === 'pa') {
                this.productos.sort((a, b) => a.precio -  b.precio);
            } else if (this.orden === 'pd') {
                this.productos.sort((a, b) => b.precio - a.precio);
            }
        }
    }

    private filtrar() {
        if (this.filtro.length > 0) {
            const texto = this.filtro.toUpperCase();
            this.productos = this.todosLosProductos.filter(
                producto => 
                    producto.nombre.toUpperCase().includes(texto)                
            );
            this.googleAnalyticsService.eventEmitter("ecommerce", this.nombre, "filtrar" , this.filtro);
            this.ordenar();
        } else {
            this.productos = this.todosLosProductos;
            this.ordenar();
        }
    }

    keyDownFunction(event) {
        if (event.keyCode === 13) {
            this.filtrar();
        }
    }

    private loadLista() {
        this.restService.get('/rest-api/public/lista/find?nombre=' + this.nombre + '&codigo=' + this.codigo).subscribe(
            data => {
                this.lista = data;
                if (!data) {                    
                    this.error = true;
                }
            }
        );
    }

    private loadProductos() {
        this.restService.getAll('/rest-api/public/producto').subscribe(data => {
            this.todosLosProductos = data;
            this.productos = data;
        });
    }

    add(producto: Producto) {
        let sel = this.pedido.items.find(s => s.producto.id === producto.id);
        if (sel) {
            sel.cantidad = sel.cantidad + 1;
            this.googleAnalyticsService.eventEmitter("add_to_cart", this.nombre, producto.nombre , "incrementar", sel.cantidad);
        } else {
            this.pedido.items.push(new Item(producto));
            this.googleAnalyticsService.eventEmitter("add_to_cart", this.nombre, producto.nombre , "agregar", 1);
        }
        if (this.anonima) {
            this.router.navigate(['/elegir'], { queryParams: {anonima: true}, fragment: 'resumen'});
        } else {
            this.router.navigate(['/elegir'], { queryParams: {nombre: this.nombre, codigo: this.codigo}, fragment: 'resumen'});
        }

    }

    delete(producto: Producto) {
        let sel = this.pedido.items.find(s => s.producto.id === producto.id);
        if (sel.cantidad > 1) {
            sel.cantidad = sel.cantidad - 1;
            this.googleAnalyticsService.eventEmitter("remove_from_cart", this.nombre, producto.nombre , "decrementar", sel.cantidad);
        } else {
            const index = this.pedido.items.indexOf(sel, 0);
            if (index > -1) {
                this.pedido.items.splice(index, 1);
            }
            this.googleAnalyticsService.eventEmitter("remove_from_cart", this.nombre, producto.nombre , "eliminar", 0);
        }
    }


}